module.exports = __webpack_public_path__ + "static/media/jardinero.085c8a40.png";